const caclulateHeaderHeight = ({ brandHeader, subNavigation }) => {
  let totalHeight = 0;

  if (brandHeader) {
    totalHeight += brandHeader.offsetHeight;
  }

  if (subNavigation) {
    totalHeight += subNavigation.offsetHeight;
  }

  return totalHeight;
};

export default caclulateHeaderHeight;
